var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status-circle",class:{
    'filled': _vm.filled,
    'current': _vm.current
  },attrs:{"title":_vm.current ? 'Current Status' : ''}})}
var staticRenderFns = []

export { render, staticRenderFns }